var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnifeCss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "92.059px",
    height: "32px",
    viewBox: "0 0 92.059 32",
    enableBackground: "new 0 0 92.059 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guides"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M72.948,12.353c-11.712-2.169-28.352-1.323-28.352-1.323s-0.106,0.382-0.364,0.382 c-0.258,0-0.374-0.382-0.374-0.382l-0.444,0.018c0,0-0.116,0.391-0.382,0.391s-0.354-0.337-0.354-0.337l-0.471,0.009 c0,0-0.125,0.364-0.382,0.373c-0.257,0.009-0.337-0.355-0.337-0.355l-0.479,0.009c0,0-0.035,0.355-0.355,0.364 c-0.32,0.009-0.355-0.346-0.355-0.346l-0.506,0.009c0,0-0.063,0.337-0.355,0.346s-0.329-0.355-0.329-0.355l-0.489,0.018 c0,0-0.124,0.391-0.408,0.391s-0.364-0.4-0.364-0.4l-4.682,0.098l0.675-2.248V8.755l-0.941-0.693l-0.249,0.125l-0.79,1.999 l-0.782,0.675l-0.897,0.364l-1.679,0.089l-0.213,0.337l-0.364,0.213v-0.213l-0.178-0.257L6.639,11.9l-0.595,0.586v0.506H5.706 l-0.399,0.391v0.417H4.916l-0.417,0.391v0.444H4.099l-0.373,0.346v0.436l-0.32-0.036l-0.427,0.364v0.409H2.58l-0.453,0.56 l1.108,2.805l5.07-0.764l16.332-1.82c0,0,1.82-0.049,1.934-0.082c0.114-0.031,0.219-0.39,0.382-0.39s0.317,0.293,0.317,0.293 s1.567,0.258,1.917,1.796c0.268,1.178-0.26,2.624-0.26,2.624l0.91,0.552c0,0,0.357-0.617,0.715-1.332 c0.357-0.715,0.455-1.332,0.455-1.332s1.584-1.748,3.9-0.943c2.56,0.89,2.535,3.607,2.535,3.607s4.063-2.015,11.277-2.242 s10.4,0.846,19.533,0.813c9.133-0.032,15.34-4.858,15.34-4.858S81.504,13.937,72.948,12.353z M4.49,18.422 c-0.492,0-0.89-0.42-0.89-0.938s0.398-0.938,0.89-0.938c0.491,0,0.89,0.42,0.89,0.938S4.981,18.422,4.49,18.422z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnifeCss);
export default __webpack_public_path__ + "static/media/knife_css.db2f972920e366d28b5ffbd448a0c665.svg";
export { ForwardRef as ReactComponent };